import ExportButton from '@/components/Chart/ExportButton';
import { useAppCsvExport } from '@/components/Chart/hooks/useAppCsvExport';
import { Permission } from '@/entities/permissions';
import usePermission from '@/shared/hooks/usePermission';

const ExportCsvButton = ({
  tabName,
  disabled = false
}: {
  tabName: string;
  disabled?: boolean;
}) => {
  const { handleExport, exportDisabled } = useAppCsvExport(tabName, disabled);
  const { hasPermission } = usePermission();
  const isPermissionGranted = hasPermission(Permission.ExportBasic);
  const buttonDisabled = exportDisabled || !isPermissionGranted;
  return (
    <ExportButton
      disabled={buttonDisabled}
      handleClick={handleExport}
      title='Download as CSV'
    />
  );
};

export default ExportCsvButton;
